import { faTrash } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FlexRow } from "app-styled/flex";
import styled, { css } from "styled-components";

const IconWrapper = styled(FlexRow)`
  ${({ theme }) => css`
    .fa-primary {
      fill: ${theme["smylor-blue-darken-D"]} !important;
      opacity: unset;
    }
    .fa-secondary {
      fill: ${theme["smylor-light-blueA"]} !important;
      opacity: unset;
    }
  `}
`;

const SmylorDeleteIcon = ({ onClick }: { onClick: Function }) => {
  return (
    <IconWrapper onClick={onClick}>
      <FontAwesomeIcon icon={faTrash} />
    </IconWrapper>
  );
};

export { SmylorDeleteIcon };
